import React from "react"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import iconArrowBack from "assets/temp/icons/icon-arrow-back.svg"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import { useI18nContext } from "i18n/i18n-react"

export default function AmuletStackerNavControls(props) {
  const { LL } = useI18nContext()
  const {
    hasProducts,
    isReviewing,
    rearrange,
    onChangeChainClick,
    onRearrangeClick,
  } = props
  return (
    <div className="stacker-controls w-100">
      {(!rearrange || !isMobile()) && (
        <button
          className="btn btn-change-chain btn-std d-none d-lg-block"
          onClick={onChangeChainClick}
        >
          <InlineSVGIcon
            alt={LL.amulets.changeChain()}
            className={"mr-1"} //d-inline
            style={{ display: "inline-block", height: 11, width: 6.7 }}
            iconSvgText={iconArrowBack}
          />
          <span className="align-text-top text-secondary">
            {LL.amulets.changeChain()}
          </span>
        </button>
      )}
      {hasProducts && !isReviewing && (
        <button
          className="btn btn-rearrange btn-std"
          onClick={onRearrangeClick}
        >
          {!rearrange ? LL.amulets.rearrange() : LL.amulets.done()}
        </button>
      )}
    </div>
  )
}

AmuletStackerNavControls.propTypes = {
  hasProducts: PropTypes.bool.isRequired,
  isReviewing: PropTypes.bool,
  rearrange: PropTypes.bool.isRequired,
  onChangeChainClick: PropTypes.func.isRequired,
  onRearrangeClick: PropTypes.func.isRequired,
}
